import { ApiLoadingSpinner, Button } from "@funcional/react-ui";
import { useState } from "react";

import { useParams } from "react-router-dom";
import Basic from "../components/DropzoneTwo";
import { uploadFileCpfErrors } from "../contracts/upload-file-cpf";
import { useUploadFile } from "../hooks/useUpload-file";

interface IFileUpload {
  file?: File;
}

interface Props {
  closeModal: () => void;
  nameFileUploadModal: (name: string) => void;
}

export default function UploadFilePage({
  closeModal,
  nameFileUploadModal,
}: Props) {
  let { params }: { params: string } = useParams();

  const [uploadError, setUploadError] = useState<uploadFileCpfErrors>();
  const [successUpload, setSuccessUpload] = useState<boolean>(false);
  const [selectedFile, setSelectFile] = useState<File>();
  const { mutateAsync, isLoading } = useUploadFile();

  const sendFiles = async () => {
    let fileUpload: IFileUpload = { file: selectedFile };
    const { errors, successfulUpload } = await mutateAsync(fileUpload as any);
    setUploadError(errors.shift());
    setSuccessUpload(successfulUpload);
    setSelectFile(undefined);

    if (successfulUpload) {
      const name = selectedFile?.name || "";
      nameFileUploadModal(name);
    }
  };

  return (
    <>
      <div className="w-full mt-2 flex flex-col">
        {isLoading ? (
          <ApiLoadingSpinner message="Enviando o arquivo..." />
        ) : null}

        {!isLoading && !successUpload ? (
          <Basic onFileUploaded={setSelectFile} errorUpload={uploadError} />
        ) : null}

        {successUpload ? (
          <>
            <h4>Arquivo enviado com sucesso.</h4>
          </>
        ) : null}

        <div className="w-full flex justify-end mt-2">
          <div className="flex-shrink-0 mt-2">
            {successUpload ? (
              <>
                <Button
                  color="primary"
                  className="max-w-full w-48 text-center"
                  onClick={closeModal}
                >
                  Fechar
                </Button>
              </>
            ) : (
              <>
                <Button
                  color="primary"
                  className="max-w-full w-48 text-center"
                  disabled={!selectedFile}
                  onClick={sendFiles}
                >
                  ENVIAR
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
